// @ts-nocheck


import React from 'react';


import { fuelAndOilApi } from '../../lib/api';

import AutocompleteSelect from './AutocompleteSelect';

import {
  fuelAndOilGroup,
  fuelAndOilSubType,
  fuelAndOilSubView,
  fuelAndOilView,
  fuelAndOilType } from
'../../lib/enum';









const FuelAndOilSelect = ({
  filter = {},
  disabledValues,
  ...selectProps
}) =>
<AutocompleteSelect
  fetch={async (params) =>
  await fuelAndOilApi.fetchFuelsAndOils({ ...params, ...filter })
  }
  fetchSingle={fuelAndOilApi.fetchFuelAndOil}
  notFoundText="ГСМ не найдено"
  renderOption={(fuelAndOil, Option) =>
  <Option
    value={fuelAndOil.id}
    key={fuelAndOil.id}
    disabled={disabledValues.includes(fuelAndOil.id)}
    fuelandoil={fuelAndOil}>

        {fuelAndOil.name} | {fuelAndOilView[fuelAndOil.view]} |&nbsp;
        {fuelAndOilSubView[fuelAndOil.subView]}
        {fuelAndOil.type && ` | ${fuelAndOilType[fuelAndOil.type]}`}
        {fuelAndOil.subType && ` | ${fuelAndOilSubType[fuelAndOil.subType]}`}
        {fuelAndOil.group && ` | ${fuelAndOilGroup[fuelAndOil.group]}`}
      </Option>
  }
  {...selectProps} />;



FuelAndOilSelect.defaultProps = {
  disabledValues: []
};

export default FuelAndOilSelect;
